<template>
  <div class="personal-container">
    <!-- 个人信息卡片 -->
    <el-card class="profile-header">
      <div class="user-info-section">
        <div class="avatar-section">
          <el-avatar :size="100"
                     :src="fixImageUrl(userInfo.avatar) || 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'"></el-avatar>
          <el-upload
              class="avatar-uploader"
              :action="uploadUrl"
              :headers="uploadHeaders"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :on-error="handleAvatarError"
              :before-upload="beforeAvatarUpload"
              name="file"
              style="margin-top: 10px;">
            <el-button size="small" icon="el-icon-upload">上传头像</el-button>
          </el-upload>
        </div>

        <div class="info-grid">
          <div class="info-item">
            <label>手机号码：</label>
            <span>{{ maskPhone(userInfo.phone) }}</span>
            <el-button type="text" size="small" @click="showPhoneDialog = true">修改</el-button>
          </div>
          <div class="info-item">
            <label>电子邮箱：</label>
            <span>{{ maskEmail(userInfo.email) }}</span>
            <el-button type="text" size="small" @click="showEmailDialog = true">修改</el-button>
          </div>
          <div class="info-item">
            <label>注册时间：</label>
            <span>{{ formatDate(userInfo.registeredAt) }}</span>
          </div>
          <div class="info-item">
            <label>所在企业：</label>
            <span style="color: #409EFF;">{{ userInfo.companyName || '未认领' }}</span>
          </div>
        </div>
      </div>
    </el-card>

    <!-- 基础信息 -->
    <el-card class="info-card">
      <div slot="header" class="card-header">
        <h3>基础信息</h3>
      </div>

      <el-form :model="userInfo" :rules="rules" ref="userForm" label-width="120px">
        <el-row :gutter="40">
          <el-col :span="12">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="userInfo.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="公司名称" prop="companyName">
              <el-input v-model="userInfo.companyName" placeholder="请输入公司名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="40">
          <el-col :span="12">
            <el-form-item label="部门" prop="department">
              <el-input v-model="userInfo.department" placeholder="请输入部门"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="职位" prop="position">
              <el-input v-model="userInfo.position" placeholder="请输入职位"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="40">
          <el-col :span="12">
            <el-form-item label="国家及地区" prop="country">
              <el-select v-model="userInfo.country" placeholder="请选择国家/地区" style="width: 100%;"
                         @change="handleCountryChange">
                <el-option
                    v-for="country in countryList"
                    :key="country.value"
                    :label="country.label"
                    :value="country.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="省/市/区" prop="province">
              <el-cascader
                  v-if="currentProvinceOptions.length > 0"
                  v-model="selectedRegion"
                  :options="currentProvinceOptions"
                  :props="cascaderProps"
                  @change="handleRegionChange"
                  placeholder="请选择省/市/区"
                  style="width: 100%;">
              </el-cascader>
              <el-input
                  v-else
                  v-model="userInfo.province"
                  placeholder="请输入省/市/区">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="40">
          <el-col :span="12">
            <el-form-item label="详细地址" prop="detailedAddress">
              <el-input v-model="userInfo.detailedAddress" placeholder="请输入详细地址"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮政编码" prop="postalCode">
              <el-input v-model="userInfo.postalCode" placeholder="请输入邮政编码"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <!-- 您关注的产品和领域（只显示父节点） -->
    <el-card class="interest-card">
      <div slot="header" class="card-header">
        <h3>您关注的产品和领域 <span style="color: #F56C6C; font-size: 14px;">（至少选一项）</span> ：</h3>
      </div>

      <div class="interest-content">
        <el-checkbox-group v-model="selectedCategories" @change="handleCategorySelectionChange">
          <el-checkbox
              v-for="category in categoryList"
              :key="category.id"
              :label="category.id">
            {{ category.name }}
          </el-checkbox>
        </el-checkbox-group>

        <el-alert
            v-if="selectedCategories.length === 0"
            title="请选择您感兴趣的行业选项"
            type="info"
            :closable="false"
            style="margin-top: 15px;">
        </el-alert>
      </div>
    </el-card>

    <!-- 您所在的行业（根据选择的产品动态显示子节点） -->
    <el-card class="interest-card" v-if="industryGroups.length > 0">
      <div slot="header" class="card-header">
        <h3>您所在的行业 <span style="color: #F56C6C; font-size: 14px;">（至少选一项）</span> ：</h3>
      </div>

      <div class="interest-content">
        <div v-for="group in industryGroups" :key="group.categoryId" class="category-group">
          <div class="category-title">{{ group.categoryName }}</div>
          <el-checkbox-group v-model="selectedIndustryIds">
            <el-checkbox
                v-for="industry in group.industries"
                :key="industry.id"
                :label="industry.id">
              {{ industry.name }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </el-card>

    <!-- 保存按钮 -->
    <div class="save-section">
      <el-button type="primary" size="large" @click="saveProfile" :loading="saving" style="width: 200px;">
        保存
      </el-button>
    </div>

    <!-- 修改手机号对话框 -->
    <el-dialog title="修改手机号" :visible.sync="showPhoneDialog" width="400px">
      <el-form :model="phoneForm" ref="phoneForm">
        <el-form-item label="新手机号">
          <el-input v-model="phoneForm.newPhone" placeholder="请输入新手机号"></el-input>
        </el-form-item>
        <el-form-item label="验证码">
          <el-input v-model="phoneForm.code" placeholder="请输入验证码">
            <el-button slot="append" @click="sendPhoneCode" :disabled="phoneCountdown > 0">
              {{ phoneCountdown > 0 ? `${phoneCountdown}秒后重发` : '发送验证码' }}
            </el-button>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showPhoneDialog = false">取消</el-button>
        <el-button type="primary" @click="updatePhone">确定</el-button>
      </div>
    </el-dialog>

    <!-- 修改邮箱对话框 -->
    <el-dialog title="修改邮箱" :visible.sync="showEmailDialog" width="400px">
      <el-form :model="emailForm" ref="emailForm">
        <el-form-item label="新邮箱">
          <el-input v-model="emailForm.newEmail" placeholder="请输入新邮箱"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showEmailDialog = false">取消</el-button>
        <el-button type="primary" @click="updateEmail">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";
import {countryList, countryRegionMap} from "@/utils/regionData";
import { getUploadUrl, fixImageUrl } from '@/config/api';

export default {
  name: "PersonalView",
  data() {
    return {
      userInfo: {
        id: null,
        name: '',
        phone: '',
        email: '',
        avatar: '',
        companyName: '',
        country: '中国',
        province: '',
        city: '',
        district: '',
        detailedAddress: '',
        postalCode: '',
        department: '',
        position: '',
        registeredAt: ''
      },
      rules: {
        name: [{required: true, message: '请输入姓名', trigger: 'blur'}],
        companyName: [{required: true, message: '请输入公司名称', trigger: 'blur'}],
        country: [{required: true, message: '请选择国家/地区', trigger: 'change'}],
        position: [{required: true, message: '请输入职位', trigger: 'change'}],
        department: [{required: true, message: '请输入所在部门', trigger: 'change'}],
        detailedAddress: [{required: true, message: '请输入详细地址', trigger: 'change'}],
        province: [{required: true, message: '请选择省/市/区', trigger: 'change'}]
      },
      categoryTree: [], // 完整的树形数据
      categoryList: [], // 只包含产品/领域的列表（父节点）
      selectedCategories: [], // 选中的产品/领域ID
      selectedIndustryIds: [], // 选中的行业ID
      industryGroups: [], // 按产品/领域分组的行业
      saving: false,
      uploadUrl: getUploadUrl(),
      uploadHeaders: {},
      countryList: countryList,
      currentProvinceOptions: [],
      selectedRegion: [],
      cascaderProps: {
        value: 'value',
        label: 'label',
        children: 'children'
      },
      showPhoneDialog: false,
      showEmailDialog: false,
      phoneForm: {
        newPhone: '',
        code: ''
      },
      emailForm: {
        newEmail: ''
      },
      phoneCountdown: 0
    }
  },
  mounted() {
    // 先加载分类树，再加载用户信息（确保数据依赖正确）
    this.loadCategoryTree().then(() => {
      this.loadUserInfo();
    });
  },
  methods: {
    // 修复图片URL
    fixImageUrl(url) {
      return fixImageUrl(url);
    },

    // 加载用户信息
    loadUserInfo() {
      const user = localStorage.getItem('user');
      if (user) {
        const userData = JSON.parse(user);
        this.userInfo = {...this.userInfo, ...userData};

        // 设置上传请求头
        this.uploadHeaders = {
          token: userData.token
        };

        // console.log('个人资料页面 - 设置上传token:', userData.token);
        // console.log('个人资料页面 - 上传URL:', this.uploadUrl);

        // 处理省市数据
        if (this.userInfo.country) {
          this.handleCountryChange(this.userInfo.country);

          // 解析省市区 - 使用三级数据
          if (this.userInfo.province && this.userInfo.city && this.userInfo.district) {
            this.selectedRegion = [this.userInfo.province, this.userInfo.city, this.userInfo.district];
          } else if (this.userInfo.province && this.userInfo.city) {
            // 兼容旧数据（只有省市）
            this.selectedRegion = [this.userInfo.province, this.userInfo.city];
          }
        }

        // 加载用户关注
        this.loadUserInterests();
      }
    },

    // 加载分类树
    loadCategoryTree() {
      return request.get('/category/tree').then(res => {
        if (res.code === '200') {
          this.categoryTree = res.data;
          // 提取只包含产品/领域的列表（父节点）
          this.categoryList = res.data.map(item => ({
            id: item.id,
            name: item.name,
            code: item.code
          }));
          // console.log('分类树加载完成:', this.categoryTree);
        }
      });
    },

    // 加载用户关注
    loadUserInterests() {
      request.get('/user/interests').then(res => {
        // console.log('用户关注接口返回:', res);

        if (res.code === '200' && res.data && res.data.length > 0) {
          const interests = res.data;
          // console.log('用户关注数据:', interests);

          // 提取所有选中的ID（包括产品/领域和行业）
          const categoryIds = new Set();
          const industryIds = new Set();

          interests.forEach(interest => {
            categoryIds.add(interest.categoryId);
            if (interest.industryId) {
              industryIds.add(interest.industryId);
            }
          });

          this.selectedCategories = Array.from(categoryIds);
          this.selectedIndustryIds = Array.from(industryIds);

          // console.log('选中的产品/领域ID:', this.selectedCategories);
          // console.log('选中的行业ID:', this.selectedIndustryIds);

          // 使用nextTick确保DOM更新后再处理
          this.$nextTick(() => {
            // 更新可选择的行业（必须在categoryTree加载完成后）
            if (this.categoryTree.length > 0) {
              this.updateAvailableIndustries();
              // console.log('行业分组数据:', this.industryGroups);
            }
          });
        } else {
          // console.log('用户暂无关注数据或返回为空');
        }
      }).catch(error => {
        // console.error('加载用户关注失败:', error);
      });
    },

    // 处理产品/领域选择变化
    handleCategorySelectionChange() {
      this.updateAvailableIndustries();
    },

    // 更新可选择的行业（只显示选中的产品/领域对应的行业）
    updateAvailableIndustries() {
      this.industryGroups = [];

      // 只为选中的产品/领域显示其行业
      this.categoryTree.forEach(category => {
        if (this.selectedCategories.includes(category.id) && category.children && category.children.length > 0) {
          // console.log(`为产品 ${category.name} 添加行业:`, category.children);
          this.industryGroups.push({
            categoryId: category.id,
            categoryName: category.name,
            industries: category.children
          });
        }
      });

      // 清理不再有效的行业选择（如果取消选中了某个产品/领域）
      const validIndustryIds = [];
      this.industryGroups.forEach(group => {
        group.industries.forEach(industry => {
          validIndustryIds.push(industry.id);
        });
      });

      this.selectedIndustryIds = this.selectedIndustryIds.filter(id =>
          validIndustryIds.includes(id)
      );

    },

    // 国家变化处理
    handleCountryChange(country) {
      this.selectedRegion = [];
      if (countryRegionMap[country]) {
        this.currentProvinceOptions = countryRegionMap[country];
      } else {
        this.currentProvinceOptions = [];
      }
    },

    // 省市选择变化处理
    handleRegionChange(value) {
      // console.log('省市区选择变化:', value);
      if (value && value.length === 3) {
        // 三级选择：省、市、区
        this.userInfo.province = value[0];
        this.userInfo.city = value[1];
        this.userInfo.district = value[2];
      } else if (value && value.length === 2) {
        // 兼容两级选择：省、市
        this.userInfo.province = value[0];
        this.userInfo.city = value[1];
        this.userInfo.district = '';
      } else if (value && value.length === 1) {
        // 只选择了省
        this.userInfo.province = value[0];
        this.userInfo.city = '';
        this.userInfo.district = '';
      }
      // console.log('更新后的地址信息:', {
      //   province: this.userInfo.province,
      //   city: this.userInfo.city,
      //   district: this.userInfo.district
      // });
    },

    // 保存个人资料
    saveProfile() {
      this.$refs.userForm.validate((valid) => {
        if (valid) {
          if (this.selectedCategories.length === 0) {
            this.$message.warning('请至少选择一个行业');
            return;
          }

          this.saving = true;

          // 更新用户基本信息
          request.put('/user/update', this.userInfo).then(res => {
            if (res.code === '200') {
              // 更新用户关注
              this.saveUserInterests();
            } else {
              this.$message.error(res.msg || '保存失败');
              this.saving = false;
            }
          }).catch(() => {
            this.saving = false;
          });
        }
      });
    },

    // 保存用户关注
    saveUserInterests() {
      const interests = [];

      // 构建关注数据
      this.selectedCategories.forEach(categoryId => {
        // 检查该产品/领域下是否有选中的行业
        const category = this.categoryTree.find(c => c.id === categoryId);
        if (category && category.children) {
          const selectedIndustries = category.children.filter(industry =>
              this.selectedIndustryIds.includes(industry.id)
          );

          if (selectedIndustries.length > 0) {
            // 如果选中了行业，为每个行业创建记录
            selectedIndustries.forEach(industry => {
              interests.push({
                categoryId: categoryId,
                industryId: industry.id
              });
            });
          } else {
            // 如果只选中产品/领域，没选行业
            interests.push({
              categoryId: categoryId,
              industryId: null
            });
          }
        }
      });

      // 保存关注
      request.post('/user/set-interests', interests).then(res => {
        if (res.code === '200') {
          this.$message.success('保存成功');
          // 更新本地存储
          const user = JSON.parse(localStorage.getItem('user'));
          Object.assign(user, this.userInfo);
          localStorage.setItem('user', JSON.stringify(user));
          // 刷新页面
          window.location.reload();
        } else {
          this.$message.error(res.msg || '保存关注失败');
        }
      }).finally(() => {
        this.saving = false;
      });
    },

    // 头像上传成功
    handleAvatarSuccess(res) {
      // console.log('头像上传成功响应:', res);
      if (res.code === '200') {
        this.userInfo.avatar = res.data;
        this.$message.success('头像上传成功');
      } else {
        this.$message.error('上传失败: ' + (res.msg || '未知错误'));
      }
    },

    // 头像上传失败
    handleAvatarError(err, file, fileList) {
      // console.error('头像上传失败:', err);
      // console.error('文件信息:', file);
      this.$message.error('头像上传失败，请检查网络连接或文件格式');
    },

    // 上传前验证
    beforeAvatarUpload(file) {
      const isImage = file.type.startsWith('image/');
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isImage) {
        this.$message.error('只能上传图片文件！');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB！');
        return false;
      }
      return true;
    },

    // 发送手机验证码
    sendPhoneCode() {
      if (!this.phoneForm.newPhone) {
        this.$message.warning('请输入新手机号');
        return;
      }

      request.post('/user/send-code', null, {
        params: {
          phone: this.phoneForm.newPhone,
          type: 'update'
        }
      }).then(res => {
        if (res.code === '200') {
          this.$message.success('验证码已发送');
          this.phoneCountdown = 60;
          this.startCountdown();
        }
      });
    },

    // 倒计时
    startCountdown() {
      const timer = setInterval(() => {
        this.phoneCountdown--;
        if (this.phoneCountdown <= 0) {
          clearInterval(timer);
        }
      }, 1000);
    },

    // 更新手机号
    updatePhone() {
      request.put('/user/update-phone', {
        phone: this.phoneForm.newPhone,
        code: this.phoneForm.code
      }).then(res => {
        if (res.code === '200') {
          this.$message.success('手机号已更新，请重新登录');
          //等待一秒后刷新页面
          setTimeout(() => {
            this.showPhoneDialog = false;
            // 退出重新登录
            localStorage.removeItem('user');
            window.location.reload();
          }, 1000);
        } else {
          this.$message.error(res.msg || '更新失败');
        }
      });
      this.showPhoneDialog = false;
      this.phoneForm.newPhone = '';
      this.phoneForm.code = '';
    },

    // 更新邮箱
    updateEmail() {
      if (!this.emailForm.newEmail) {
        this.$message.warning('请输入新邮箱');
        return;
      }

      this.userInfo.email = this.emailForm.newEmail;
      this.showEmailDialog = false;
      this.$message.success('邮箱已更新，请点击保存按钮');
    },

    // 手机号脱敏
    maskPhone(phone) {
      if (!phone) return '';
      return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    },

    // 邮箱脱敏
    maskEmail(email) {
      if (!email) return '';
      const parts = email.split('@');
      if (parts.length === 2) {
        const username = parts[0];
        if (username.length > 2) {
          return username.substring(0, 1) + '****' + username.substring(username.length - 1) + '@' + parts[1];
        }
      }
      return email;
    },

    // 格式化日期
    formatDate(date) {
      if (!date) return '';
      return new Date(date).toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    }
  }
}
</script>

<style scoped>
/* ========== 页面容器 ========== */
.personal-container {
  padding: 40px 30px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf2 100%);
  min-height: 100vh;
  max-width: 1400px;
  margin: 0 auto;
}

/* ========== 个人信息头部卡片 ========== */
.profile-header {
  margin-bottom: 24px;
  border-radius: 16px;
  border: none;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  overflow: hidden;
}

.profile-header >>> .el-card__body {
  padding: 0;
}

.user-info-section {
  display: flex;
  gap: 40px;
  padding: 40px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
}

.avatar-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.avatar-section >>> .el-avatar {
  border: 4px solid white;
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.3);
  transition: all 0.3s;
}

.avatar-section >>> .el-avatar:hover {
  transform: scale(1.05);
  box-shadow: 0 12px 32px rgba(102, 126, 234, 0.4);
}

.avatar-uploader >>> .el-button {
  background: var(--primary-gradient);
  border: none;
  color: white;
  border-radius: 20px;
  padding: 8px 20px;
  transition: all 0.3s;
}

.avatar-uploader >>> .el-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.info-grid {
  flex: 1;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  align-items: center;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  border-radius: var(--radius-md);
  background: rgba(102, 126, 234, 0.03);
  transition: all 0.3s;
}

.info-item:hover {
  background: rgba(102, 126, 234, 0.08);
  transform: translateX(5px);
}

.info-item label {
  font-weight: 600;
  color: var(--text-secondary);
  white-space: nowrap;
  font-size: 14px;
}

.info-item span {
  color: var(--text-primary);
  font-weight: 500;
  flex: 1;
}

.info-item >>> .el-button--text {
  color: var(--primary-color);
  font-weight: 600;
  padding: 0 8px;
}

/* ========== 信息卡片 ========== */
.info-card, .interest-card {
  margin-bottom: var(--spacing-lg);
  border-radius: var(--radius-lg);
  border: none;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s;
}

.info-card:hover, .interest-card:hover {
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
}

.card-header h3 {
  margin: 0;
  color: var(--text-primary);
  font-size: 18px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 10px;
}

.card-header h3::before {
  content: '';
  width: 4px;
  height: 20px;
  background: var(--primary-gradient);
  border-radius: 2px;
}

/* ========== 表单样式 ========== */
.info-card >>> .el-form {
  padding: 0 10px;
}

.info-card >>> .el-form-item__label {
  font-weight: 600;
  color: var(--text-secondary);
}

.info-card >>> .el-input__inner,
.info-card >>> .el-textarea__inner {
  border-radius: var(--radius-md);
  border: 1px solid var(--border-light);
  transition: all 0.3s;
}

.info-card >>> .el-input__inner:focus,
.info-card >>> .el-textarea__inner:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.info-card >>> .el-select,
.info-card >>> .el-cascader {
  width: 100%;
}

/* ========== 关注区域 ========== */
.interest-content {
  padding: 30px;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.02) 0%, rgba(118, 75, 162, 0.02) 100%);
  border-radius: var(--radius-md);
}

.interest-content .el-checkbox-group {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 16px 24px;
}

.interest-content >>> .el-checkbox {
  margin: 0;
  padding: 10px 16px;
  border-radius: var(--radius-md);
  background: white;
  border: 2px solid #e4e7ed;
  transition: all 0.3s;
}

.interest-content >>> .el-checkbox:hover {
  border-color: var(--primary-color);
  background: rgba(102, 126, 234, 0.05);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);
}

.interest-content >>> .el-checkbox.is-checked {
  background: white;
  border-color: var(--primary-color);
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.2);
}

.interest-content >>> .el-checkbox.is-checked .el-checkbox__label {
  color: var(--primary-color);
  font-weight: 600;
}

.interest-content >>> .el-checkbox__inner {
  border-radius: 4px;
  transition: all 0.3s;
}

.interest-content >>> .el-checkbox.is-checked .el-checkbox__inner {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
}

.interest-content >>> .el-checkbox__label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
  padding-left: 8px;
  color: var(--text-primary);
  transition: all 0.3s;
}

.interest-content >>> .el-alert {
  border-radius: var(--radius-md);
  border: none;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
}

/* ========== 行业分组 ========== */
.category-group {
  margin-bottom: 35px;
  padding: 25px;
  background: white;
  border-radius: var(--radius-lg);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  transition: all 0.3s;
}

.category-group:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.category-title {
  font-weight: 700;
  color: transparent;
  background: var(--primary-gradient);
  background-clip: text;
  -webkit-background-clip: text;
  margin-bottom: 20px;
  font-size: 16px;
  padding-bottom: 12px;
  border-bottom: 3px solid transparent;
  border-image: var(--primary-gradient) 1;
  display: flex;
  align-items: center;
  gap: 10px;
}

.category-title::before {
  content: '📋';
  font-size: 20px;
}

/* ========== 保存按钮区域 ========== */
.save-section {
  text-align: center;
  margin: 40px 0;
  padding: 30px;
  background: white;
  border-radius: var(--radius-lg);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.save-section >>> .el-button {
  height: 50px;
  padding: 0 60px;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 700;
  background: var(--primary-gradient);
  border: none;
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3);
  transition: all 0.3s;
}

.save-section >>> .el-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 28px rgba(102, 126, 234, 0.4);
}

.save-section >>> .el-button:active {
  transform: translateY(-1px);
}

/* ========== 对话框美化 ========== */
.personal-container >>> .el-dialog {
  border-radius: var(--radius-lg);
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.15);
}

.personal-container >>> .el-dialog__header {
  background: var(--primary-gradient);
  padding: 20px;
  border-radius: var(--radius-lg) var(--radius-lg) 0 0;
}

.personal-container >>> .el-dialog__title {
  color: white;
  font-weight: 700;
  font-size: 18px;
}

.personal-container >>> .el-dialog__headerbtn .el-dialog__close {
  color: white;
  font-size: 20px;
}

.personal-container >>> .el-dialog__body {
  padding: 30px;
}

.personal-container >>> .el-dialog__footer {
  padding: 20px 30px;
  border-top: 1px solid var(--border-lighter);
}

/* ========== 响应式设计 ========== */
@media (max-width: 768px) {
  .personal-container {
    padding: var(--spacing-md);
  }

  .user-info-section {
    flex-direction: column;
    padding: 30px 20px;
    gap: 25px;
  }

  .info-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .interest-content .el-checkbox-group {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 12px 16px;
  }

  .category-group {
    padding: 20px 15px;
  }

  .save-section >>> .el-button {
    width: 100%;
    padding: 0 40px;
  }
}

/* ========== 动画效果 ========== */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.profile-header,
.info-card,
.interest-card,
.save-section {
  animation: fadeInUp 0.6s ease-out;
}

.info-card {
  animation-delay: 0.1s;
}

.interest-card:nth-of-type(1) {
  animation-delay: 0.2s;
}

.interest-card:nth-of-type(2) {
  animation-delay: 0.3s;
}

.save-section {
  animation-delay: 0.4s;
}
</style>
